import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=21ff81d4&scoped=true&"
import script from "./ShareDialog.vue?vue&type=script&lang=js&"
export * from "./ShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&id=21ff81d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff81d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VContainer,VFlex,VIcon,VLayout,VProgressCircular})
